import { BookOpen, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";

const HelpCenter = () => {
  const { t } = useI18n();

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <div className="page-container mx-auto py-12 space-y-8">
        <div className="glass-card p-8 space-y-4">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
            <BookOpen className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-3xl font-bold">{t('support.helpCenter.title')}</h1>
          <p className="text-muted-foreground">
            {t('support.helpCenter.subtitle')}
          </p>
          <div className="flex flex-wrap gap-3">
            <Button variant="outline">{t('support.helpCenter.quickGuide')}</Button>
            <Button variant="outline">{t('support.helpCenter.faq')}</Button>
            <Button variant="outline">{t('support.helpCenter.discordSetup')}</Button>
          </div>
        </div>

        <div className="glass-card p-8 space-y-3">
          <h2 className="text-xl font-semibold">{t('support.helpCenter.needSupport')}</h2>
          <p className="text-muted-foreground">{t('support.helpCenter.needSupportDesc')}</p>
          <div className="flex flex-wrap gap-3">
            <Link to="/support/discord">
              <Button className="gap-2"><LifeBuoy className="w-4 h-4" />{t('support.helpCenter.communityDiscord')}</Button>
            </Link>
            <Link to="/support/contact">
              <Button variant="outline">{t('support.helpCenter.sendRequest')}</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
